import React, { useState, useEffect } from "react";

import profileImage from "../../../assets/images/profile.png";
import "./Header.css";
import { useNavigate, Navigate, Link, useLocation } from "react-router-dom";
// @ts-ignore
import { OverlayTrigger, Tooltip, Dropdown } from "react-bootstrap";
// @ts-ignore
import {
  processLogout,
  setInValidUser,
} from "../../../redux/actions/authActions/authAction";
import { useSelector, useDispatch } from "react-redux";
import { viewSingleUser } from "../../../redux/actions/userAction/userAction";
import CommonModal from "../CommonModal";
import { logOutMessage } from "../../../constants/constatntMessages";
import {
  clearState,
  setCreateNewMeetingPage,
} from "../../../redux/actions/meetingActions/MeetingAction";
import io from "socket.io-client";
import { viewAllNotifications } from "../../../redux/actions/notificationAction/NotificationAction";
import { openSidebar } from "../../../redux/actions/commonActions/commonAction";
import { setOrganizationData } from "../../../redux/actions/organizationAction/OrganizationAction";
import { toast } from "react-toastify";
import * as constantMessages from "../../../constants/constatntMessages";
import axios from "axios";
import { handleApiError } from "../../../helpers/errorResponseHelper";
import ProfileDialog from "../Profile/ProfileModalOld";
const Header = React.memo(() => {
  document.body.classList.remove("landing-page");

  const socket = io.connect(process.env.REACT_APP_API_URL, {
    transports: ["websocket"], // keep this if you want only websocket
    reconnection: true, // enable reconnection (default true)
    reconnectionAttempts: Infinity, // keep retrying forever
    reconnectionDelay: 1000, // start reconnect after 1 second
    reconnectionDelayMax: 5000, // max delay between reconnect tries
    timeout: 20000, // timeout for initial connection
  });

  const [name, setName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const authData = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const userData = JSON.parse(localStorage.getItem("userData"));
  const accessToken = localStorage.getItem("accessToken");
  const navigate = useNavigate();
  const handleLogout = () => {
    if (localStorage.getItem("accessToken")) {
      dispatch(processLogout(localStorage.getItem("accessToken")));
    }

    setIsModalOpen(false);
    socket.emit("notification", "message from frontend");
  };
  const location = useLocation();
  const employeeData = useSelector((state) => state.user);
  const notificationData = useSelector((state) => state.notification);
  const [isToolTipOpen, setIsToolTipOpen] = useState(true);

  let notificationCalled = false;
  useEffect(() => {
    if (userData && localStorage.getItem("accessToken")) {
      setName(employeeData.userData?.name);
      dispatch(
        viewSingleUser(userData._id, localStorage.getItem("accessToken"))
      );
    } else {
      navigate("/login");
    }

    socket.on("connection", () => {
      // console.log(`I'm connected with the back-end`);
    });

    socket.on("notification", (message) => {
      notificationCalled = true;

      if (localStorage.getItem("accessToken")) {
        if (!authData.isInValidUser) {
          dispatch(
            viewAllNotifications(
              { organizationId: userData.organizationId },
              localStorage.getItem("accessToken")
            )
          );
        }
      }
    });

    if (notificationCalled === false && localStorage.getItem("accessToken")) {
      if (!authData.isInValidUser) {
        dispatch(
          viewAllNotifications(
            { organizationId: userData?.organizationId },
            localStorage.getItem("accessToken")
          )
        );
      }
    }
    return () => {};
  }, [notificationData.isSuccess, authData.isInValidUser]);

  useEffect(() => {
    if (!authData.isInValidUser && userData) {
      fetchOrganization(userData?.organizationId);
    }
  }, [authData.isInValidUser]);

  const fetchOrganization = async (organizationId) => {
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/V1/organization/viewSingleOrganization/${organizationId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
        }
      );

      if (response?.data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        dispatch(setInValidUser(false));
      }
      dispatch(setOrganizationData(response.data.data));
      return response.data;
    } catch (error) {
      if (handleApiError(error)) return;
    }
  };

  const nitificationDatalength =
    employeeData?.userData?.isAdmin === true
      ? notificationData?.notificationList?.filter(
          (notification) => notification?.isRead === false
        )?.length
      : notificationData?.notificationList?.filter(
          (notification) =>
            notification?.allowedUsers?.includes(userData?._id?.toString()) &&
            notification?.isRead === false
        )?.length;

  const tooltip = (attendee) => {
    return (
      <Tooltip id="tooltip">
        {attendee?.name} / {attendee?.email}
      </Tooltip>
    );
  };

  const renderTooltip = (nitificationDatalength) => (
    <Tooltip id="notification-tooltip">{nitificationDatalength}</Tooltip>
  );

  const handleNotificationClick = () => {};
  const handleClick = (event) => {
    if (event.ctrlKey) {
      event.preventDefault(); // Prevents opening in new tab
      event.stopPropagation(); // Prevents bubbling up if needed

      return;
    }

    dispatch(
      setCreateNewMeetingPage({
        status: true,
        isClearingleMeetingDetails: false,
      })
    );
    dispatch(clearState(true));
    // Clear the location.state by replacing current history entry
    navigate(location.pathname, { replace: true, state: {} });
  };

  const [profilePicture, setProfilePicture] = useState(null);
  const [preview, setPreview] = useState("");
  const [headerProfilePicture, setHeaderProfilePicture] = useState(null);
  const [isConfirming, setIsConfirming] = useState(false);
  const employee = employeeData.userData;
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const handleEditClick = (emp) => {
   // alert(1)
    setSelectedEmployee(emp);
    setIsConfirming(false);
    setIsProfileModalOpen(true);
          dispatch(
        viewSingleUser(userData._id, localStorage.getItem("accessToken"))
      );
  };
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  const [imageError, setImageError] = useState(false);

  useEffect(() => {
       setProfilePicture("");
      setPreview("");
      setHeaderProfilePicture("");
    if (employeeData?.userData?.profilePicture) {
      const formattedProfilePicture =
        employeeData.userData.profilePicture.startsWith("http")
          ? employeeData.userData.profilePicture
          : `${baseUrl}${employeeData.userData.profilePicture}`;

      setProfilePicture(formattedProfilePicture);
      setPreview(formattedProfilePicture);
      setHeaderProfilePicture(formattedProfilePicture);
      setImageError(false); // Reset error if image changes
    }
  }, [employeeData, baseUrl]);
  // useEffect(() => {
  //   if(authData?.isLogInByChangeOrgSuccess){
  //   //  alert("in reload meetinglist")
  //     navigate("/");
  //    // dispatch(resetStates())
  //   }

  // }, [authData?.isLogInByChangeOrgSuccess]);

  const employeeName =
    employeeData?.userData?.name?.split(" ")?.length > 0
      ? employeeData?.userData?.name?.split(" ")[0]
      : name;
  return (
    <>
      {!localStorage.getItem("accessToken") ||
      employeeData?.userData === null ? (
        <Navigate to="/login" />
      ) : null}
      {!accessToken ? <Navigate to="/login" /> : null}
      {authData?.isLogInByChangeOrgSuccess ? (
        <Navigate to="/meeting-list" />
      ) : null}
      <section className="topbar">
        <div
          className="topbar-1"
          onMouseEnter={() => {
            setIsToolTipOpen(true);
          }}
        >
          <div className="topbar1-content">
            <div className="d-flex align-items-center">
              <button
                className="ps-0 sidebar-open-btn "
                onClick={() => dispatch(openSidebar())}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  fill="#000"
                  className="bi bi-list"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
                  />
                </svg>
              </button>
              <div className="meeting">MinutesVault</div>
            </div>

            <div className="top-right-svg headerpprofile">
              {employeeData?.userData?.isMeetingOrganiser === true ||
              employeeData?.userData?.isAdmin ? (
                <>
                  <div className="create-meeting-button ">
                    <Link
                      to="/create-meeting?new=true"
                      state={{ isNewMeeting: true }}
                      style={{ textDecoration: "none" }}
                    >
                      <button
                        className="create-meeting-button Mom-btn filter-height "
                        onClick={handleClick} // Using the handleClick to detect key press
                      >
                        <p>Create Meeting</p>
                      </button>
                    </Link>
                  </div>
                  <div className="line"></div>
                </>
              ) : null}

              <Link
                to="/notification"
                onClick={handleNotificationClick}
                state={{ camefromPreviousPage: true }}
              >
                {nitificationDatalength > 99 ? (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      isToolTipOpen ? (
                        renderTooltip(nitificationDatalength)
                      ) : (
                        <></>
                      )
                    }
                    trigger={["hover", "focus"]}
                  >
                    <div className="bell">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        fill="#000"
                        className="bi bi-bell"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
                      </svg>
                      <span>99+</span>
                    </div>
                  </OverlayTrigger>
                ) : (
                  <div className="bell">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      fill="#000"
                      className="bi bi-bell"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
                    </svg>
                    <span>{nitificationDatalength}</span>
                  </div>
                )}
              </Link>
              <div className="line"></div>

              <Dropdown
                onToggle={() => {
                  setIsToolTipOpen(false);
                }}
              >
                <Dropdown.Toggle>
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      isToolTipOpen ? tooltip(employeeData?.userData) : <></>
                    }
                    trigger={["hover", "focus"]}
                  >
                    <div className="d-flex admin-box">
                      {/* <img src={headerProfilePicture || profileImage} className="user" /> */}
                      <img
                        src={
                          imageError
                            ? profileImage
                            : headerProfilePicture || profileImage
                        }
                        onError={() => setImageError(true)}
                        className="user"
                      />

                      <span>
                        Hi,{" "}
                        {employeeName?.length > 6
                          ? employeeName?.slice(0, 6) + "..."
                          : employeeName}
                        {employeeData?.userData?.isAdmin ? "(Admin)" : null}
                      </span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-down"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                        />
                      </svg>
                    </div>
                  </OverlayTrigger>
                </Dropdown.Toggle>

                <Dropdown.Menu className="resp-font14">
                  <Link
                    to="#"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    <Dropdown.Item className="resp-profile">
                      <svg
                        id="Layer_1"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-box-arrow-left me-2"
                        data-name="Layer 1"
                      >
                        <path
                          d="m412.7 426.9c-5.132-68.879-54.826-125.53-120.282-141.121a88.584 88.584 0 1 0 -72.832 0c-65.458 15.591-115.167 72.242-120.286 141.121a231.444 231.444 0 0 1 -75.3-170.921c0-127.919 104.081-232 231.991-232 127.934 0 232.017 104.081 232.017 232a231.427 231.427 0 0 1 -75.308 170.921zm-156.709-426.92c-141.15 0-255.991 114.84-255.991 255.999s114.842 256 255.992 256c141.176 0 256.005-114.842 256.005-256s-114.83-255.999-256.006-255.999z"
                          fill-rule="evenodd"
                        />
                      </svg>
                      <span>
                        {employeeName?.length > 4
                          ? employeeName?.slice(0, 4)
                          : employeeName}{" "}
                        {employeeData?.userData?.isAdmin ? "(Admin)" : null}
                      </span>
                    </Dropdown.Item>

                    <Dropdown.Item
                      eventKey="4"
                      onClick={() => {
                        handleEditClick(employee);
                        setIsProfileModalOpen(true);
                        setIsToolTipOpen(false);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="me-2 bi bi-pencil-square"
                        viewBox="0 0 16 16"
                      >
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                        <path
                          fillRule="evenodd"
                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                        />
                      </svg>
                      Profile
                    </Dropdown.Item>

                    <Dropdown.Item
                      eventKey="4"
                      onClick={() => {
                        setIsModalOpen(true);
                        setIsToolTipOpen(false);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19"
                        height="19"
                        fill="currentColor"
                        className="bi bi-box-arrow-left me-2"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5.5 0 0 1 6.5 2h8A1.5.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0z"
                        />
                        <path
                          fill-rule="evenodd"
                          d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708z"
                        />
                      </svg>
                      Logout
                    </Dropdown.Item>
                  </Link>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
        <CommonModal
          message={logOutMessage}
          title={"Logout"}
          setIsModalOpen={setIsModalOpen}
          isModalOpen={isModalOpen}
          handleSubmit={handleLogout}
          buttonName={"Logout"}
        />
        <ProfileDialog
          setShowEditModal={setIsProfileModalOpen}
          showEditModal={isProfileModalOpen}
          onClose={() => setIsProfileModalOpen(false)}
          employee={selectedEmployee}
        />
      </section>
    </>
  );
});

export default Header;
